<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title">Update Application Statement</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li><a routerLink="/locations" routerLinkActive="active">Locations</a></li>
        <li class="separator">></li>
        <li class="active">Update Application Statement</li>
      </ul>
    </div>
  </div>
  <div class="mat-card-wrapper">
    <mat-card-content class="mcd-card-content">
      <form [formGroup]="updateStatementForm">
        <div class="editor-outer-container">
          <quill-editor 
            name="statement" 
            formControlName="statement" 
            class="quill-editor-css"  
            [preserveWhitespace]="true"
            (onEditorCreated)="onEditorCreated($event)"
          >
          </quill-editor>
        </div>
      </form>

      <!-- Action Buttons Row (Cancel bottom-left, Update bottom-right) -->
      <div class="actions-row">
        <button 
          type="button" 
          class="btn-cancel" 
          (click)="onCancelClick()"
        >
          Cancel
        </button>

        <button 
          type="button" 
          class="btn-submit" 
          (click)="saveApplicationStatement()"
        >
          Update
        </button>
      </div>
    </mat-card-content>
    <mat-card-footer class="mcd-card-footer"> </mat-card-footer>
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
